export default __webpack_public_path__ + "static/media/SecretsMockup.850a649f.jpg";